export class BaseUrlParam {
    constructor(
        public name: string,
        public flushed: boolean,
    ) {}

    public toString(): string {
        return this.name;
    }
}
